export const subjectClaimsQueryKeys = {
  all: ['subjectClaims'] as const,
  currentClaims: (params: { userUuid: string; entityUuid: string }) =>
    [...subjectClaimsQueryKeys.all, 'currentClaims', params] as const,
  publicationStoryClaim: (params: {
    publicationId: string;
    subjectId: string;
    storyId?: string;
    entityUuid: string;
    storiesAccessControlEnabled: boolean;
  }) => [...subjectClaimsQueryKeys.all, 'publicationStoryClaim', params] as const,
  storyClaims: (storyId: string) => [...subjectClaimsQueryKeys.all, 'storyClaims', storyId] as const,
  publicationClaims: (params: { publicationId: string; publicationClaims?: string[] }) =>
    [...subjectClaimsQueryKeys.all, 'publicationClaims', params] as const,
  userGroups: (params: { subjectId: string; entityUuid: string }) =>
    [...subjectClaimsQueryKeys.all, 'userGroups', params] as const
};
